import React, { useCallback, useEffect, useState } from 'react';
import { Box, Flex, Loading, Text } from '@cko/primitives';
import styled from 'styled-components';
import PdfToolbar from './PdfToolbar';
import PdfRenderer from './PdfRenderer';
import usePdf, { Status } from './usePdf';
const ElementAbove = styled(Box) `
  z-index: 1;
`;
const PdfContainer = styled(Box) `
  background-color: var(--control-bg-secondary);
  width: 100%;
  height: 100%;
  overflow: auto;
  text-align: center;
`;
// Multi-line block of text with ellipsis
// https://dropshado.ws/post/1015351370/webkit-line-clamp
const ErrorText = styled(Text) `
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font: var(--body-sm-emphasis);
  margin: var(--layout-spoon);
  color: var(--base-text-bad);
`;
export const PdfViewer = (props) => {
    const { url, title } = props;
    const [page, setPage] = useState(1);
    const [scale, setScale] = useState(1);
    const { status, error, pdfDocument, pdfPage, loadPdf, loadPage } = usePdf();
    /* istanbul ignore next */
    const goNextPage = useCallback(() => {
        setPage((currentPage) => currentPage + 1);
    }, []);
    /* istanbul ignore next */
    const goPreviousPage = useCallback(() => {
        setPage((currentPage) => currentPage - 1);
    }, []);
    /* istanbul ignore next */
    const setZoom = useCallback((zoom) => {
        setScale(zoom / 100);
    }, []);
    useEffect(() => {
        loadPdf(url);
    }, [loadPdf, url]);
    useEffect(() => {
        loadPage(page);
    }, [loadPage, page]);
    return (React.createElement(Flex, { alignItems: "center", flexDirection: "column", height: "100%", justifyContent: "center", width: "100%" },
        React.createElement(ElementAbove, { width: "100%" },
            React.createElement(PdfToolbar, { isDisabled: status !== Status.success, onClickNextPage: goNextPage, onClickPreviousPage: goPreviousPage, onZoomChange: setZoom, page: page, pageCount: pdfDocument?.numPages || 0, title: title, zoom: scale * 100 })),
        React.createElement(PdfContainer, null,
            status === Status.failure && error && (React.createElement(Flex, { alignItems: "center", "data-testid": "pdf-viewer-error", height: "100%", justifyContent: "center", width: "100%", padding: "var(--layout-stadium)" },
                React.createElement(ErrorText, null, error.message))),
            status === Status.loading && (React.createElement(Flex, { alignItems: "center", "data-testid": "pdf-viewer-loading", height: "100%", justifyContent: "center", width: "100%" },
                React.createElement(Loading, { width: "100px" }))),
            status === Status.success && pdfPage && (React.createElement(Box, { "data-testid": "pdf-viewer-success", display: "inline-block", margin: "var(--layout-saxophone) var(--layout-saxophone) var(--layout-stadium)", height: "100%", width: "100%" },
                React.createElement(PdfRenderer, { pdfPage: pdfPage, scale: scale }))))));
};
